const accountModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  templateUrl: '/modules/users/account-list/account-modal/account-modal.html',
  controller: 'AccountModalController',
};

angular
  .module('users.module')
  .component('accountModal', accountModal);
